
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import { StudyCategory } from '@/models/StudyCategory'
import SelectModal from '@/components/templates/SelectModal.vue'
import { StudyCategoriesApi } from '@/api/methods/StudyCategoriesApi'

/**
 * 通常授業サポート教材選択モーダル
 */
@Component({
  components: {
    SelectModal,
  },
})
export default class ModalSelectGeneralStudyCategory extends Vue {
  /** 選択用モーダル */
  @Ref()
  private selectModal!: SelectModal

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmitStudyCategory!: (id: number) => void

  /** 選択中の学年コード */
  @Prop()
  private currentGradeCode!: string

  /** 選択中の教科コード */
  @Prop()
  private currentSubjectCode!: string

  /** 通常授業サポート教材のリスト */
  private studyCategoryList: StudyCategory.General[] = []

  /**
   * 通常授業サポート教材コード一覧(IDを引当てコードとして使用)
   *
   * @returns 通常授業サポート教材コード(ID)のリスト
   */
  private get studyCategoryCodeList(): string[] {
    return this.studyCategoryList.map((category) => `${category.id}`)
  }

  /**
   * ボタン押下時のイベント
   */
  private submitStudyCategory(): void {
    this.selectModal.hide()
    this.eventSubmitStudyCategory(parseInt(this.selectModal.currentItemCode))
  }

  /**
   * 通常授業サポート教材IDからラベルを引当てて返す
   *
   * @param id 通常授業サポート教材ID
   * @returns 通常授業サポート教材のラベル
   */
  private getLabelById(id: string): string {
    const label = this.studyCategoryList.find((category) => category.id === Number(id))?.name
    return label || ''
  }

  /**
   * モーダルを開く
   *
   * @param currentStudyCategoryId 現在の通常授業サポート教材ID
   */
  public show(currentStudyCategoryId: string): void {
    this.$loading.start()
    this.getStudyCategoryData()
    this.$loading.complete()
    this.selectModal.show(currentStudyCategoryId)
  }

  /**
   * 通常授業サポート教材のリストを取得
   */
  private async getStudyCategoryData(): Promise<void> {
    // api実行
    const studyCategories = await StudyCategoriesApi.getGenerals(this.currentGradeCode, this.currentSubjectCode)
    this.studyCategoryList = studyCategories.map((studyCategory) => {
      return {
        id: studyCategory.id,
        code: studyCategory.code,
        name: studyCategory.name,
        textbookImagePath: studyCategory.textbookImagePath,
      }
    })
  }
}
